import { inject, observer } from 'mobx-react'
import React, { useCallback, useEffect } from 'react'
import { Empty, Pagination, Table } from 'antd'
import { TableBottomPaginationBlock } from '../../../components/Common/Table'
import './style.css'
import { Link } from 'react-router-dom'
import { AppTablePagination } from '../../../components/AppTable/AppTablePagination'
import { AppTable } from '../../../components/AppTable/AppTable'

const ExportDistributeVoteTable = props => {
  const { managementAssetWarehouseStore, isLoading } = props

  const {
    assetStatisticList,
    pageIndex,
    sizeIndex,
    totalCount,
  } = managementAssetWarehouseStore

  useEffect(() => {
    ;(async () => {
      await managementAssetWarehouseStore.clearFilter()
    })()
  }, [])

  const handleChangePage = useCallback(
    p => {
      const pageIndex = p - 1
      managementAssetWarehouseStore.setFilter('pageIndex', pageIndex)
    },
    [managementAssetWarehouseStore]
  )

  const assetTypeNames = assetStatisticList?.assetTypeNames || []
  const tableColumns = [
    {
      title: <span className="custom-header">STT</span>,
      width: '30px',
      render: (id, record, index) => <span>{index + 1}</span>,
      align: 'center',
      fixed: 'left',
      ellipsis: true,
    },
    {
      title: <span className="custom-header">Tên đơn vị</span>,
      width: '200px',
      render: record => <span>{record.departmentName}</span>,
      align: 'center',
      fixed: 'left',
      ellipsis: true,
    },
    ...assetTypeNames.map(type => ({
      title: <span className="custom-header">Số lượng</span>,
      width: '70px',
      render: record => {
        const asset = record.assetTypeList.find(asset => asset.name === type)
        return (
          <span>
            {asset && typeof asset.quantity === 'number'
              ? asset.quantity.toLocaleString('vi-VN')
              : '----'}
          </span>
        )
      },
      align: 'center',
      ellipsis: true,
    })),
    {
      title: <span className="custom-header">Tổng thuế trước</span>,
      width: '110px',
      render: record => <span>{record.preTax?.toLocaleString('vi-VN')}</span>,
      align: 'center',
      fixed: 'right',
      ellipsis: true,
    },
    {
      title: <span className="custom-header">Tổng thuế sau</span>,
      width: '110px',
      render: record => (
        <span>{Math.round(record.afterTax)?.toLocaleString('vi-VN')}</span>
      ),
      align: 'center',
      fixed: 'right',
      ellipsis: true,
    },
  ]

  return (
    <>
      <div style={{ overflowX: 'auto' }}>
        <AppTable
          scroll={{ x: 'max-content' }}
          bordered
          // @ts-ignore
          dataSource={assetStatisticList?.statisticsResponses || []}
          // @ts-ignore
          columns={tableColumns}
          rowClassName={(record, index) =>
            index % 2 === 0 ? 'row-white' : 'row-blue'
          }
          pagination={false}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description={'Không có dữ liệu'}
              />
            ),
          }}
          loading={isLoading}
          rowKey={record => record.departmentName}
          expandable={{
            expandedRowRender: record => (
              <div>
                <AppTable
                  dataSource={record?.assetHistories || []}
                  pagination={false}
                  columns={[
                    {
                      title: <span className="custom-header">STT</span>,
                      width: '30px',
                      render: (id, record, index) => <span>{index + 1}</span>,
                      align: 'center',
                      fixed: 'left',
                      ellipsis: true,
                    },
                    {
                      title: <span className="custom-header">Người tạo</span>,
                      width: '57px',
                      render: (id, record, index) => (
                        <Link
                          to={`/distribution-votes/other/view/${record.proposalCode}`}
                          target="_blank"
                          rel="noopener noreferrer">
                          {record.userName}
                        </Link>
                      ),
                      align: 'center',
                      fixed: 'left',
                      ellipsis: true,
                    },
                    {
                      title: <span className="custom-header">Tên tài sản</span>,
                      width: '200px',
                      render: record => <span>{record.assetName}</span>,
                      align: 'center',
                      fixed: 'left',
                      ellipsis: true,
                    },
                    {
                      title: <span className="custom-header">Số lượng</span>,
                      width: '70px',
                      render: record => <span>{record.quantity}</span>,
                      align: 'center',
                      ellipsis: true,
                    },
                    {
                      title: (
                        <span className="custom-header">Tổng thuế trước</span>
                      ),
                      width: '110px',
                      render: record => (
                        <span>
                          {(record.price * record.quantity)?.toLocaleString(
                            'vi-VN'
                          )}
                        </span>
                      ),
                      align: 'center',
                      fixed: 'right',
                      ellipsis: true,
                    },
                    {
                      title: (
                        <span className="custom-header">Tổng thuế sau</span>
                      ),
                      width: '110px',
                      render: record => (
                        <span>
                          {Math.round(
                            (record.price + (record.price * record.tax) / 100) *
                              record.quantity
                          )?.toLocaleString('vi-VN')}
                        </span>
                      ),
                      align: 'center',
                      fixed: 'right',
                      ellipsis: true,
                    },
                  ]}
                />
                {/* <div style={{ display: 'inline-block' }}>
                  tổng:{' '}
                  {record?.assetHistories.reduce(
                    (sum, item) => sum + item.quantity,
                    0
                  )}
                </div> */}
              </div>
            ),
          }}
        />
      </div>

      <AppTablePagination
        current={pageIndex + 1}
        pageSize={sizeIndex}
        total={totalCount}
        onChange={handleChangePage}
        showSizeChanger={false}
        showQuickJumper={false}
      />
    </>
  )
}

export default inject('managementAssetWarehouseStore')(
  observer(ExportDistributeVoteTable)
)
